<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     充值购物车
  | @Version:   2018-11-27  [A] 新建文件
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="ap-recharge-cart mt-md mb-md">
    <div class="main-body">
      <el-card v-if="!carts.length" v-loading="cartsLoading" class="left" :body-style="{ height: '100%' }" shadow="never">
        <div class="cart-empty">
          <div class="font-8x text-light">
            <span class="iconfont icon-shapping-cart"></span>
          </div>
          <div class="font-2x text-light">购物车为空</div>
          <div class="mt flex align-items-center">
            <el-link type="success" :underline="false" icon="el-icon-magic-stick" @click="importAll">导入所有已欠费</el-link>
            <el-dropdown trigger="click">
              <span class="text-primary">
                <i class="el-icon-arrow-down el-icon--right mt-xs"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="exportMonth()">导入所有本月底到期</el-dropdown-item>
                <el-dropdown-item @click.native="exportNextMonth()">导入所有下月底到期</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <el-button type="warning" plain size="small" class="mt" @click="cartDOC">了解充值</el-button>
        </div>
      </el-card>

      <el-card v-else v-loading="cartsLoading" class="left" shadow="never">
        <div slot="header" class="flex align-items-center">
          <div class="bd font-lg flex align-items-center">
            <span>购物车共有</span>
            <span class="text-success ml-xs mr-xs mt-xs">{{ carts.length }}</span>
            <span>个接入点</span>
            <el-alert title="多年优惠，续费时长越长，折扣力度越大" type="warning" :closable="false" style="width: 290px;" class="ml"></el-alert>
          </div>
          <div class="ft">
            <el-link :underline="false" icon="el-icon-brush" @click="clearAll">清空</el-link>
          </div>
        </div>
        <el-table :data="carts" class="cart-table" :row-class-name="tableRowClassName">
          <el-table-column type="index" label="#" width="50"></el-table-column>
          <el-table-column min-width="200px" label="设备/编号/类型" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="ap-info-cell">
                <f-equip-name :equip="{ equipid: scope.row.equipid, equip_name: scope.row.equip_name }" />
                <el-link class="ap-info-simid text-muted mt-xs mb-xs" :underline="false" @click="toApDialog(scope.row)">{{ scope.row.simid }}</el-link>
                <div class="ap-info-ap-model text-muted">{{ scope.row.ap_model }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="105px" label="当前有效期">
            <template slot-scope="scope">
              <span v-if="scope.row.first_activation == 0" class="text-success">{{ formatPrechargeLabel(scope.row.precharge_month) }}</span>
              <span v-else-if="scope.row.old_expire_day" :class="scope.row.old_expire_day < new Date() / 1000 && 'text-danger'">{{ scope.row.old_expire_day | parseTime('{y}/{m}/{d}') }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column min-width="115px" label="充值后有效期">
            <template slot-scope="scope">
              <span v-if="scope.row.first_activation == 0" class="text-success">{{ formatPrechargeLabel(scope.row.precharge_month + scope.row.num * 12) }}</span>
              <span v-else-if="scope.row.new_expire_day" :class="scope.row.new_expire_day < new Date() / 1000 && 'text-danger'">{{ scope.row.new_expire_day | parseTime('{y}/{m}/{d}') }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column min-width="75px" label="单价" align="right">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.price_frippler_face * scope.row.discount_rate | currency }}</span>
                <span class="text-muted">/年</span>
              </div>
              <div v-if="scope.row.discount_rate < 1" class="text-muted" style="font-size: 12px;height: 12px;line-height: 12px">
                <s>
                  <span>{{ scope.row.price_frippler_face | currency }}</span>
                  <span class="text-muted">/年</span>
                </s>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="100px" align="right">
            <template slot="header" slot-scope="scope">
              <el-dropdown trigger="click" @command="updateRowAll({num: $event, row: scope.row})">
                <span class="el-dropdown-link">
                  <span>续费时长</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="customer-dropdown-menu">
                  <el-dropdown-item v-for="year in yearArr2" :key="year.year_num + 'year'" :command="year.year_num" class="customer-dropdown-item1" :class="year.year_num == activeNum && 'active'">
                    <div class="flex align-items-center time-option" style="height: 100%;">
                      <div style="width: 80px;" class="text-center">{{ year.year_num }}年</div>
                      <div v-if="year.year_num != 0" style="width: 150px;" class="text-orange border-left">{{ year.discount_rate < 1 ? `${year.discount_rate * 10}折` : '无折扣' }}</div>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <div slot-scope="scope" @click="handleClick(scope.row)">
              <el-dropdown trigger="click" @command="updateRow({ num: $event, row: scope.row })">
                <span>
                  <span>{{ scope.row.num }}年</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="customer-dropdown-menu">
                  <el-dropdown-item
                    v-for="year in yearArr"
                    :key="year.year_num + 'year'"
                    :command="year.year_num"
                    class="customer-dropdown-item"
                    :class="year.year_num == scope.row.num && 'active'"
                  >
                    <div class="flex align-items-center time-option" style="height: 100%;">
                      <div style="width: 80px;" class="text-center">{{ year.year_num }}年</div>
                      <div class="border-left" style="width: 150px;">
                        <span style="font-size: 16px">{{ year.discount_rate < 1 ? '￥' + year.price : '￥' + year.market_price }}</span>
                        <span v-if="year.discount_rate < 1" style="font-size: 12px; text-decoration: line-through;" class="ml-xs text-muted">￥{{ year.market_price }}</span>
                      </div>
                      <div v-if="year.year_num != 0" style="width: 150px;" class="text-orange border-left">{{ year.discount_rate < 1 ? `优惠后￥${year.price / year.year_num}/年` : '无优惠' }}</div>
                      <div v-if="year.recommended" class="recommend">推荐</div>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-table-column>

          <el-table-column min-width="115px" label="数据存储" align="right">
            <template slot="header" slot-scope="scope">
              <el-dropdown trigger="click" @command="updateDssAll({num: $event, row: scope.row})">
                <span class="el-dropdown-link">
                  <span>数据存储</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="dsso in dssOptions"
                    :key="dsso.days + 'dsso'"
                    :command="dsso.days"
                    :class="dsso.days == activeDss && 'active'"
                  >{{ dsso.days <= 7 ? '不购买' : `保留${dsso.days}天` }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <div class="service-config-cell">
                <el-dropdown class="service-dropdown" trigger="click" @command="updateRow({ dss_days: $event, row: scope.row })">
                  <span class="service-dropdown-trigger">
                    <span class="service-config-content">
                      <span v-if="scope.row.new_dss_days > 7" class="service-price">{{ scope.row.dss_market_price | currency }}</span>
                      <span class="service-option">{{ scope.row.new_dss_days <= 7 ? '不购买' : `保留${scope.row.new_dss_days}天` }}</span>
                    </span>
                    <i class="service-arrow el-icon-arrow-down"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="dsso in dssOptions"
                      :key="dsso.days + 'dsso'"
                      :command="dsso.days"
                      :class="dsso.days == scope.row.new_dss_days && 'active'"
                    >{{ dsso.days <= 7 ? '不购买' : `保留${dsso.days}天` }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>

          <el-table-column min-width="95px" label="高级功能" align="right">
            <template slot="header" slot-scope="scope">
              <el-dropdown trigger="click" @command="updateProVersionAll({pro_version: $event, row: scope.row})">
                <span class="el-dropdown-link">
                  <span>高级功能</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="1" :class="activeProVersion === 1 && 'active'">开通</el-dropdown-item>
                  <el-dropdown-item :command="0" :class="activeProVersion === 0 && 'active'">不开通</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <div class="service-config-cell">
                <el-dropdown class="service-dropdown" trigger="click" @command="updateRow({ pro_version: $event, row: scope.row })">
                  <span class="service-dropdown-trigger">
                    <span class="service-config-content">
                      <span v-if="scope.row.new_pro_version === 1" class="service-price">{{ scope.row.rms_pro_market_price | currency }}</span>
                      <span class="service-option">{{ scope.row.new_pro_version === 1 ? '开通' : '不开通' }}</span>
                    </span>
                    <i class="service-arrow el-icon-arrow-down"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="1" :class="scope.row.new_pro_version === 1 && 'active'">开通</el-dropdown-item>
                    <el-dropdown-item :command="0" :class="scope.row.new_pro_version === 0 && 'active'">不开通</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>

          <el-table-column min-width="80px" label="复机费用" align="right">
            <template slot-scope="scope">
              <div><span>{{ scope.row.recover_market_price | currency }}</span></div>
            </template>
          </el-table-column>

          <el-table-column min-width="100px" label="金额小计" align="right">
            <template slot-scope="scope">
              <span v-if="checkConfig(scope.row) === 1" class="text-danger">{{ '配置未变更' }}</span>
              <span v-else-if="checkConfig(scope.row) === 2" class="text-danger">{{ '不支持降配' }}</span>
              <div v-else>
                <div>
                  {{ (scope.row.dss_market_price +
                      scope.row.rms_pro_market_price * scope.row.new_pro_version +
                      scope.row.num * scope.row.price_frippler_face * scope.row.discount_rate +
                      scope.row.recover_market_price) | currency }}
                </div>
                <div v-if="scope.row.discount_rate < 1" class="text-muted" style="font-size: 12px;height: 12px;line-height: 12px">
                  <s><span>
                    {{ (scope.row.dss_market_price +
                        scope.row.rms_pro_market_price * scope.row.new_pro_version +
                        scope.row.num * scope.row.price_frippler_face +
                        scope.row.recover_market_price) | currency }}
                  </span></s>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="35px">
            <template slot-scope="scope">
              <el-link class="hover-show" :underline="false" icon="el-icon-circle-close" @click="deleteRow(scope.row)"></el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="statistics">
          <div class="mt flex statistics-item">
            <div class="mr text-muted">商品总额：</div>
            <div class="text-right" style="padding-right: 70px;width: 150px;">{{ price.totalFace | currency }}</div>
          </div>
          <div v-if="price.totalSaved > 0" class="mt-sm statistics-item">
            <div class="mr text-muted">优惠总额：</div>
            <div class="text-right text-danger" style="padding-right: 70px;width: 150px;">-{{ price.totalSaved | currency }}</div>
          </div>
          <div class="mt-sm statistics-item">
            <div class="mr text-muted">实际金额：</div>
            <div class="text-right text-success" style="padding-right: 70px;width: 150px;">{{ price.totalAmount | currency }}</div>
          </div>
        </div>

      </el-card>

      <el-card v-loading="productsLoading" class="right" shadow="never">
        <div slot="header">
          <span class="font-lg">配置清单</span>
        </div>
        <div class="display-info sm">
          <div v-if="price.totalSaved > 0">
            <span class="text-warning text-bold">
              <i class="el-icon-present"></i> 大客户折扣
            </span>
          </div>
          <div>
            <div>
              <span class="fixed-width text-muted">商品名称：</span>
              <span>{{ product.s_title }}</span>
            </div>
            <div>
              <span class="fixed-width text-muted">购买类型：</span>
              <span>续订套餐</span>
            </div>
            <div>
              <span class="fixed-width text-muted">接入点数：</span>
              <span>{{ carts.length ? carts.length : '--' }} 个</span>
            </div>
            <div>
              <span class="fixed-width text-muted">金额总计：</span>
              <span>{{ price.totalUnitPrice | currency }}</span>
            </div>

            <el-divider></el-divider>
          </div>
          <div v-if="price.dataStoragePrice != 0">
            <div>
              <span class="fixed-width text-muted">商品名称：</span>
              <span>{{ '数据存储服务' }}</span>
            </div>
            <div>
              <span class="fixed-width text-muted">购买类型：</span>
              <span>变更配置</span>
            </div>
            <div>
              <span class="fixed-width text-muted">金额总计：</span>
              <span>{{ price.dataStoragePrice | currency }}</span>
            </div>
            <el-divider></el-divider>
          </div>

          <div v-if="price.proVersionPrice != 0">
            <div>
              <span class="fixed-width text-muted">商品名称：</span>
              <span>{{ '远程监控高级功能' }}</span>
            </div>
            <div>
              <span class="fixed-width text-muted">购买类型：</span>
              <span>变更配置</span>
            </div>
            <div>
              <span class="fixed-width text-muted">金额总计：</span>
              <span>{{ price.proVersionPrice | currency }}</span>
            </div>
            <el-divider></el-divider>
          </div>

          <div v-if="price.recoverMarketPrice != 0">
            <div>
              <span class="fixed-width text-muted">商品名称：</span>
              <span>{{ '接入点复机' }}</span>
            </div>
            <div>
              <span class="fixed-width text-muted">购买类型：</span>
              <span>复机</span>
            </div>
            <div>
              <span class="fixed-width text-muted">金额总计：</span>
              <span>{{ price.recoverMarketPrice | currency }}</span>
            </div>
            <el-divider></el-divider>
          </div>

          <div><span class="text-muted">实际费用</span></div>
          <div v-loading="updating">
            <span class="font-3x text-success">{{ price.totalAmount | currency }}</span>
            <span v-if="price.totalSaved > 0" class="ml text-warning">节省 {{ price.totalSaved | currency }}</span>
          </div>
          <el-divider></el-divider>
          <div class="mt">
            <el-button type="primary" style="width: 100%" :disabled="!(carts.length > 0) || updating || danger || price.totalAmount === 0" @click="submit">立即充值</el-button>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  apCartGetallApi,
  apCartPostApi,
  apCartDeleteApi,
  apCartClearApi,
  apCartExpiredApi,
  apCartSubmitApi,
  dssOptionsApi,
  apCartCalculateApi,
  calculateMultiYearDiscount,
  apCartDiscountRateApi,
} from "@/api/ap/apRechargeApi";

export default {
  data() {
    return {
      cartsLoading: false,
      productsLoading: false,
      updating: false,
      danger: false,
      carts: [],
      product: {},
      dssOptions: [], // 数据存储选项

      yearArr: [],
      yearArr2: [],
      activeNum: null,
      activeDss: null,
      activeProVersion: null,
    };
  },
  computed: {
    price() {
      let totalFace = 0; // 面价
      let totalAmount = 0; // 实际价格
      let fripplerPrice = 0; // 物联网接入服务价格（折扣前）
      let unitPrice = 0; // 物联网接入服务价格
      let dataStoragePrice = 0; // 数据存储价格
      let proVersionPrice = 0; // 远程监控高级功能价格
      let recoverMarketPrice = 0; // 复机费用
      let totalSaved = 0; // 节省金额

      this.carts.forEach((cur) => {
        const discount = cur.discount_rate || 1;

        fripplerPrice += cur.num * cur.price_frippler_face;
        unitPrice += cur.num * cur.price_frippler_face * discount;
        dataStoragePrice += cur.dss_market_price;
        proVersionPrice += cur.rms_pro_market_price;
        recoverMarketPrice += cur.recover_market_price;
      });
      totalFace = fripplerPrice + dataStoragePrice + proVersionPrice + recoverMarketPrice;
      totalAmount = unitPrice + dataStoragePrice + proVersionPrice + recoverMarketPrice;
      totalSaved = (totalFace - totalAmount) > 0 ? (totalFace - totalAmount) : 0;

      return { totalFace, totalAmount, totalUnitPrice: unitPrice, dataStoragePrice, proVersionPrice, recoverMarketPrice, totalSaved };
    },

  },
  watch: {
    carts(newVal, oldVal) {
      this.danger = false;
      if (newVal.some(item => this.checkConfig(item))) {
        this.danger = true;
      }
    }
  },

  created() {
    this.fetchCarts();
    this.fetchDssOptions();
    this.fetchDiscountRate();
  },
  methods: {

    toApDialog(row) {
      this.$detail({ type: "ap", id: row.simid });
    },

    formatPrechargeLabel(month) {
      const m = Math.max(0, Number(month) || 0);
      if (m >= 12 && m % 12 === 0) {
        return "预充" + m / 12 + "年";
      }
      return "预充" + m + "个月";
    },

    fetchCarts(loading = true) {
      if (loading) this.cartsLoading = true;
      apCartGetallApi().then((res) => {
        this.cartsLoading = false;
        if (res.errno === 0) {
          this.carts = res.data.list;
          this.product = Object.assign({}, res.data.list[0]);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    fetchDssOptions() {
      //获取dss选项
      this.dssOptions = [];
      dssOptionsApi().then((res) => {
        if (!res.errno) {
          this.dssOptions = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    fetchDiscountRate() {
      apCartDiscountRateApi().then(res => {
        if (res.errno === 0) {
          res.data.precharge_options.map((item,index) => {
            item.year_num = item.precharge_month / 12
            return item
          })
          this.yearArr2 = res.data.precharge_options
        } else {
          this.$message.error(res.message);
        }
      })
    },

    importAll() {
      this.cartsLoading = true;
      apCartExpiredApi().then((res) => {
        if (res.errno === 0) {
          this.$message.success(res.message);
          this.fetchCarts();
        } else {
          this.cartsLoading = false;
          this.$message.error(res.message);
        }
      });
    },

    getLastDayOfMonth(year, month) {
      // JavaScript 中的月份是从 0 开始的，所以需要减 1
      const lastDay = new Date(year, month + 1, 0);
      return lastDay;
    },

    exportMonth() {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth(); // 0 表示 1 月，11 表示 12 月

      // 获取本月底
      const endOfMonthThisMonth = this.getLastDayOfMonth(currentYear, currentMonth);
      const endtime = endOfMonthThisMonth.getTime() / 1000 + 86399;

      apCartExpiredApi({endtime}).then((res) => {
        if (res.errno === 0) {
          this.$message.success(res.message);
          this.fetchCarts();
        } else {
          this.cartsLoading = false;
          this.$message.error(res.message);
        }
      });
    },

    exportNextMonth() {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth(); // 0 表示 1 月，11 表示 12 月
      // 获取下月底
      const endOfMonthNextMonth = this.getLastDayOfMonth(currentYear, currentMonth + 1);
      const endtime = endOfMonthNextMonth.getTime() / 1000 + 86399;
      apCartExpiredApi({endtime}).then((res) => {
        if (res.errno === 0) {
          this.$message.success(res.message);
          this.fetchCarts();
        } else {
          this.cartsLoading = false;
          this.$message.error(res.message);
        }
      });
    },

    updateRowAll({ num, row }) {
      this.activeNum = num;
      this.updating = true;
      const params = this.carts.map((item) => {
        const obj = {
          cartid: item.cartid,
          simid: item.simid,
          num,
          productid: item.productid,
          new_dss_days: item.new_dss_days,
          new_pro_version: item.new_pro_version,
        };
        return obj;
      });
      this.cartsLoading = true;
      Promise.all([apCartPostApi({ data: params })]).then((res) => {
        this.updating = false;
        if (res[0].errno === 0) {
          this.fetchCarts();
        } else {
          this.fetchCarts(false);
          this.$message.error(
            res[0].errno !== 0 ? res[0].message : res[1].message
          );
        }
      });
    },

    updateDssAll({ num }) {
      this.activeDss = num;
      this.updating = true;
      const params = this.carts.map((item) => {
        const obj = {
          cartid: item.cartid,
          simid: item.simid,
          num: item.num,
          productid: item.productid,
          new_dss_days: num,
          new_pro_version: item.new_pro_version,
        };
        return obj;
      });
      this.cartsLoading = true;
      Promise.all([apCartPostApi({ data: params })]).then((res) => {
        this.updating = false;
        if (res[0].errno === 0) {
          this.fetchCarts();
        } else {
          this.fetchCarts(false);
          this.$message.error(
            res[0].errno !== 0 ? res[0].message : res[1].message
          );
        }
      });
    },

    updateProVersionAll({ pro_version }) {
      this.activeProVersion = pro_version;
      this.updating = true;
      const params = this.carts.map((item) => {
        const obj = {
          cartid: item.cartid,
          simid: item.simid,
          num: item.num,
          productid: item.productid,
          new_dss_days: item.new_dss_days,
          new_pro_version: pro_version,
        };
        return obj;
      });
      this.cartsLoading = true;
      Promise.all([apCartPostApi({ data: params })]).then((res) => {
        this.updating = false;
        if (res[0].errno === 0) {
          this.fetchCarts();
        } else {
          this.fetchCarts(false);
          this.$message.error(
            res[0].errno !== 0 ? res[0].message : res[1].message
          );
        }
      });
    },

    handleClick(row) {
      const godid = this.$store.state.godStore.godid;
      const params = {
        godid,
        cartid: row.cartid,
        simid: row.simid,
      };

      calculateMultiYearDiscount(params).then((res) => {
        if(!res.errno) {
          res.data.precharge_options.map((item,index) => {
            item.year_num = item.precharge_month / 12
            return item
          })
          this.yearArr = res.data.precharge_options
        }
      })
    },

    updateRow({ num, dss_days, pro_version, row }) {
      this.updating = true;
      const params = {
        cartid: row.cartid,
        simid: row.simid,
        num: num || num == 0 ? Number(num) : row.num,
        productid: row.productid,
        new_dss_days:
          dss_days || dss_days === 0 ? Number(dss_days) : row.new_dss_days,
        new_pro_version: pro_version !== undefined ? pro_version : row.new_pro_version,
      };
      Promise.all([
        apCartCalculateApi(params),
        apCartPostApi({ data: [params] }),
      ]).then((res) => {
        this.updating = false;
        if (res[0].errno === 0 && res[1].errno === 0) {
          row = Object.assign(row, res[0].data, { num: params.num });
          this.danger = false;
          if (this.carts.some(item => this.checkConfig(item))) {
            this.danger = true;
          }
        } else {
          this.fetchCarts(false);
          this.$message.error(
            res[0].errno !== 0 ? res[0].message : res[1].message
          );
        }
      });
    },

    deleteRow(row) {
      apCartDeleteApi({ cartids: [row.cartid] }).then((res) => {
        if (res.errno === 0) {
          this.fetchCarts(false);
        } else {
          this.fetchCarts(false);
          this.$message.error(res.message);
        }
      });
    },
    clearAll() {
      this.$confirm('确认要清空购物车吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在清空购物车...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        apCartClearApi().then((res) => {
          this.fetchCarts(false);
          loading.close();
          if (res.errno === 0) {
            this.danger = false;
            this.activeNum = null;
            this.activeDss = null;
            this.activeProVersion = null;
            this.$message.success('操作成功');
          } else {
            this.$message.error(res.message);
          }
        }).catch(() => {
          this.$message.error('清空购物车失败');
          loading.close();
        });
      })
    },
    submit() {
      this.$confirm(
        `即将提交订单，本次充值共计 <span class="font-lg text-success">${this.carts.length}</span> 个接入点，是否继续？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          type: "success",
        }
      )
        .then(() => {
          const tempData = {
            cartids: this.carts.map((v) => v.cartid),
          };
          apCartSubmitApi(tempData).then((res) => {
            if (!res.errno) {
              this.$message.success("操作成功！");
              this.$router.push({
                path: "/expense/order/cashier",
              });
              localStorage.setItem("__ORDERID__", res.data.orderid);
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    cartDOC() {
      window.open("https://wiki.frippler.com/#/docs/fs/fcs/35");
    },

    tableRowClassName({ row, rowIndex }) {
      if (this.checkConfig(row)) {
        return "danger-row";
      }
      return "";
    },

    checkConfig(row) {
      let type = 0; // 1-配置未变更 2-不支持降配
      if (row.num === 0 && row.new_dss_days == row.old_dss_days && row.new_pro_version === row.old_pro_version) {
        type = 1;
      } else if (
        (row.num === 0 || (row.num > 0 && !row.first_activation)) &&
        ((row.old_dss_days > row.new_dss_days) || (row.old_pro_version > row.new_pro_version))
      ) {
        type = 2;
      }
      return type;
    }
  },
};
</script>

<style lang="scss" scoped>
.el-dropdown-link {
  color: #909399;
}
.el-dropdown-menu__item.active {
  background-color: #e6f9ef;
  color: #07c160;
}
.main-body {
  display: flex;
  .left {
    flex: auto;
    .statistics {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .statistics-item {
        display: flex;
        justify-content: space-between;
      }
    }

  }
  .right {
    flex: none;
    width: 360px;
    margin-left: 20px;
  }
}
.cart-empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.cart-table {
  width: 100%;
  border-spacing: 0px;
  .ap-info-cell {
    line-height: 1;

    .ap-info-simid {
      font-size: 13px;

    }

    .ap-info-ap-model {
      font-size: 12px;
    }
  }
  .service-config-cell {
    line-height: 18px;

    .service-dropdown {
      width: 100%;
    }

    .service-dropdown-trigger {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
      cursor: pointer;
    }

    .service-config-content {
      min-width: 0;
      text-align: right;
    }

    .service-price {
      display: block;
      color: #303133;
    }

    .service-option {
      display: block;
      white-space: nowrap;
    }

    .service-arrow {
      flex: none;
      margin-left: 6px;
    }
  }
  tbody {
    transition: all 0.2s;
  }
  .cart-tr {
    display: table-row;
    transition: all 0.2s;
    &:hover {
      background-color: #f5f7fa;
    }
    > td {
      padding: 8px 10px;
    }
  }
}
.fixed-width {
  display: inline-block;
  width: 100px;
}
</style>
<style lang="scss">
.el-table .danger-row {
  background: #fad9d9;
}
.customer-dropdown-menu.el-dropdown-menu {
  padding: 10px;
  padding-bottom: 0;
  .customer-dropdown-item.el-dropdown-menu__item,
  .customer-dropdown-item1.el-dropdown-menu__item {
    width: 380px;
    height: 40px;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 1);
    color: rgba(16, 16, 16, 1);
    font-size: 14px;
    text-align: center;
    border: 1px solid rgba(235, 238, 245, 1);
    margin-bottom: 10px;
    padding: 0;
    &.active {
      border: 1px solid rgba(230, 162, 60, 1);
    }
    .text-orange {
      color: #F0AD4E;
    }
    .border-left {
      border-left: 1px solid rgba(235, 238, 245, 1);
    }
    .time-option {
      position: relative;
      .recommend {
        position: absolute;
        left: -1px;
        top: -1px;
        width: 32px;
        height: 18px;
        line-height: 18px;
        border-radius: 5px 5px 5px 0px;
        background: linear-gradient(91.06deg, rgba(254,167,44,1) 3.04%,rgba(253,120,34,1) 101.6%);
        color: rgba(255, 255, 255, 1);
        font-size: 10px;
        text-align: center;
      }
    }

  }
  .customer-dropdown-item1.el-dropdown-menu__item {
    width: 250px;
  }
  .flex {
    display: flex;
    &.align-items-center {
      align-items: center;
    }
    .hd,.ft {
      flex: none;
    }
    .bd {
      flex: auto;
    }
  }
}
</style>
